import moment from 'moment';

export const handleDescription = (description) => {
	if (description.length > 0) {
		const unixDate = moment.unix(description[0].created_at);
		return unixDate.format('DD/MM/YYYY HH:mm:ss');
	}
	return '-';
};
